import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { PageShell } from "@/components/layout/PageShell";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <PageShell>
      <div className="container py-16 lg:py-24" data-testid="not-found-page">
        <div className="mx-auto flex max-w-2xl flex-col items-start gap-4">
          <p className="eyebrow">§ 404 · Page not found</p>
          <h1 className="font-display text-4xl font-medium leading-tight text-foreground sm:text-5xl">
            That page could not be found.
          </h1>
          <p className="max-w-xl text-base leading-relaxed text-muted-foreground">
            The address you followed does not match a page in NDIS 0138 Readiness. The rest of the app
            is unaffected — return to the home page to start or resume a readiness assessment.
          </p>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <Button
              asChild
              className="rounded-sm px-4 text-[13px] font-medium tracking-wide shadow-paper"
            >
              <Link to="/" data-testid="not-found-home-link">
                <ArrowLeft className="h-4 w-4" />
                Back to home
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="rounded-sm border-border bg-card px-3 text-[13px] font-medium hover:bg-secondary"
            >
              <Link to="/terms" data-testid="not-found-terms-link">
                <FileText className="h-4 w-4" />
                Terms of use
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
